import router from "./router";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { loginInfo } from "@/services/landing-page/auth";

const title = process.env.VUE_APP_BASE_TITLE || "Admin Website Smarthand";

function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}

NProgress.configure({ showSpinner: false }); // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  // start progress bar
  if (!loginInfo() && to.name !== "Login") {
    router.push("/login").catch(() => { });
  } else if (to.name === "Login" && loginInfo()) {
    router.push("/").catch(() => { });
  } else {
    NProgress.start();
    // set page title
    document.title = getPageTitle(to.meta.title);
    // Handle auth logic here
    // ...
    setTimeout(() => {
      next();
      NProgress.done();
      window.scroll(0, 0);
    }, 100);
  }
});
